import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MenuIcon } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Sidebar } from "./Sidebar";

export function MobileNav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  // Close the sheet after navigating.
  useEffect(() => setOpen(false), [pathname]);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button
          type="button"
          aria-label="Open navigation"
          className="h-11 w-11 rounded-xl bg-card flex items-center justify-center text-foreground hover:bg-surface-muted transition-colors"
        >
          <MenuIcon className="h-5 w-5" strokeWidth={1.6} />
        </button>
      </SheetTrigger>
      <SheetContent side="left" className="p-0 w-[300px] bg-sidebar border-r-0">
        <SheetTitle className="sr-only">Navigation</SheetTitle>
        <Sidebar open setOpen={() => setOpen(false)} embedded />
      </SheetContent>
    </Sheet>
  );
}
